import { render, staticRenderFns } from "./MedicalRecordsList.vue?vue&type=template&id=a6edbce4&scoped=true&"
import script from "./MedicalRecordsList.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6edbce4",
  null
  
)

export default component.exports